import axios from "axios";
import { liveURL } from "../constants/Consts";

const MAIN_URL = `${liveURL}/v1/adminDiary`;
const CREATE_DIARY = `${MAIN_URL}/createDiary`;
const GET_DIARIES = `${MAIN_URL}/getDiaries`;
const GET_DIARY_BY_ID = `${MAIN_URL}/getDiary`;
const UPDATE_DIARY = `${MAIN_URL}/updateDiary`;
const DELETE_DIARY = `${MAIN_URL}/deleteDiary`;

// Create a new diary
export async function createDiary(token, data) {
  try {
    const response = await axios.post(CREATE_DIARY, data, {
      headers: { token: token },
    });
    return response.data;
  } catch (error) {
    console.log("Error creating diary:", error);
    return { Result: false, Msg: "Error creating diary" };
  }
}

// Get all diaries
export async function getDiaries(token) {
  try {
    const response = await axios.get(GET_DIARIES, {
      headers: { token: token },
    });
    return response.data;
  } catch (error) {
    console.log("Error fetching diaries:", error);
    return { Result: false, Msg: "Error fetching diaries" };
  }
}

// Get diary by ID
export async function getDiaryById(token, id) {
  try {
    const response = await axios.get(`${GET_DIARY_BY_ID}/${id}`, {
      headers: { token: token },
    });
    return response.data;
  } catch (error) {
    console.log("Error fetching diary by ID:", error);
    return { Result: false, Msg: "Error fetching diary" };
  }
}

// Update an existing diary
export async function updateDiary(token, id, data) {
  try {
    const response = await axios.put(`${UPDATE_DIARY}/${id}`, data, {
      headers: { token: token },
    });
    return response.data;
  } catch (error) {
    console.log("Error updating diary:", error);
    return { Result: false, Msg: "Error updating diary" };
  }
}

// Delete a diary
export async function deleteDiary(token, id) {
  try {
    const response = await axios.delete(`${DELETE_DIARY}/${id}`, {
      headers: { token: token },
    });
    return response.data;
  } catch (error) {
    console.log("Error deleting diary:", error);
    return { Result: false, Msg: "Error deleting diary" };
  }
}




const MUJJALAH_MAIN_URL = `${liveURL}/v1/adminMujjalah`;
const CREATE_MUJJALAH = `${MUJJALAH_MAIN_URL}/createMujjalah`;
const GET_MUJJALAH = `${MUJJALAH_MAIN_URL}/getMujjalahs`;
const GET_MUJJALAH_BY_ID = `${MUJJALAH_MAIN_URL}/getMujjalah`;
const UPDATE_MUJJALAH = `${MUJJALAH_MAIN_URL}/updateMujjalah`;
const DELETE_MUJJALAH = `${MUJJALAH_MAIN_URL}/deleteMujjalah`;

// Create a new Mujjalah
export async function createMujjalah(token, data) {
  try {
    const response = await axios.post(CREATE_MUJJALAH, data, {
      headers: { token: token },
    });
    return response.data;
  } catch (error) {
    console.log("Error creating Mujjalah:", error);
    return { Result: false, Msg: "Error creating Mujjalah" };
  }
}

// Get all Mujjalahs
export async function getMujjalahs(token) {
  try {
    const response = await axios.get(GET_MUJJALAH, {
      headers: { token: token },
    });
    return response.data;
  } catch (error) {
    console.log("Error fetching Mujjalahs:", error);
    return { Result: false, Msg: "Error fetching Mujjalahs" };
  }
}

// Get Mujjalah by ID
export async function getMujjalahById(token, id) {
  try {
    const response = await axios.get(`${GET_MUJJALAH_BY_ID}/${id}`, {
      headers: { token: token },
    });
    return response.data;
  } catch (error) {
    console.log("Error fetching Mujjalah by ID:", error);
    return { Result: false, Msg: "Error fetching Mujjalah" };
  }
}

// Update an existing Mujjalah
export async function updateMujjalah(token, id, data) {
  try {
    const response = await axios.put(`${UPDATE_MUJJALAH}/${id}`, data, {
      headers: { token: token },
    });
    return response.data;
  } catch (error) {
    console.log("Error updating Mujjalah:", error);
    return { Result: false, Msg: "Error updating Mujjalah" };
  }
}

// Delete a Mujjalah
export async function deleteMujjalah(token, id) {
  try {
    const response = await axios.delete(`${DELETE_MUJJALAH}/${id}`, {
      headers: { token: token },
    });
    return response.data;
  } catch (error) {
    console.log("Error deleting Mujjalah:", error);
    return { Result: false, Msg: "Error deleting Mujjalah" };
  }
}
